import { useMemo } from "react"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import {
    GlobalNotification,
    GlobalNotificationActions,
    GlobalNotificationActionsNames,
    GlobalNotificationSecondaryComponentNames,
    GlobalNotificationSecondaryComponents,
} from "@nova/component-global-notification"
import { defaultNotificationContext, setGlobalNotificationContext } from "user/profile/slice"
import { selectGlobalNotificationContext } from "user/profile/selectors"
import { copyState, unsubscribeToMap } from "features/pubsub/slice"
import { CopyButton } from "../buttons/CopyButton"
import { NotificationToast } from "panels/notifications/NotificationToast"

const secondaryComponents: GlobalNotificationSecondaryComponents = {
    [GlobalNotificationSecondaryComponentNames.COPY_BUTTON]: CopyButton,
}

export const GlobalNotificationContainer = () => {
    const dispatch = useAppDispatch()
    const context = useAppSelector(selectGlobalNotificationContext)

    const actions = useMemo<GlobalNotificationActions>(
        () => ({
            [GlobalNotificationActionsNames.CLONE_STATE]: () => dispatch(copyState()),
            [GlobalNotificationActionsNames.UNSUBSCRIBE_FROM_MAP]: () =>
                dispatch(unsubscribeToMap()),
            [GlobalNotificationActionsNames.AUTH_EXPIRED]: (ctx) =>
                ctx && localStorage.setItem(ctx["id"], "true"),
        }),
        [dispatch]
    )

    if (context.kind === "notification")
        return (
            <NotificationToast
                key={context.notification.id}
                notification={context.notification}
                onDismiss={() => dispatch(setGlobalNotificationContext(defaultNotificationContext))}
            />
        )

    return (
        <GlobalNotification
            context={context}
            actions={actions}
            secondaryComponents={secondaryComponents}
        />
    )
}
